import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// Import JSON files
import translationEN from "./locales/en.json";
import translationKM from "./locales/km.json";

export const supportedLngs = {
  en: "English",
  km: "Khmer",
};

i18next
  .use(initReactI18next) // Connect i18next with react
  .init({
    fallbackLng: "en", // Fallback language
    supportedLngs: Object.keys(supportedLngs),
    debug: false,
    resources: {
      en: { translation: translationEN },
      km: { translation: translationKM },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
